import React from 'react';

// BookingFlows Beacon brand mark — official artwork (transparent PNG).
export const BeaconIcon = ({ className = 'w-5 h-5' }) => (
  <img src="/beacon-icon.png" alt="" aria-hidden="true" draggable={false} className={`${className} select-none object-contain`} />
);
